/**
 * Profile image origins accepted by the signed OIDC `picture` claim.
 *
 * Keep this list deliberately small. The same sources are present in the
 * production CSP so an accepted claim can render without allowing arbitrary
 * remote content into the Tax workspace.
 */
export const AVATAR_IMAGE_CSP_SOURCES = [
    "https://*.googleusercontent.com",
    "https://avatars.githubusercontent.com",
    "https://secure.gravatar.com",
];
export const MAX_AVATAR_URL_LENGTH = 2_000;
const ALLOWED_AVATAR_HOSTS = new Set(["avatars.githubusercontent.com", "secure.gravatar.com"]);
/** Return true only for an HTTPS avatar on one of the approved image hosts. */
export function isAllowedAvatarUrl(value) {
    if (typeof value !== "string" || value.length === 0 || value.length > MAX_AVATAR_URL_LENGTH) {
        return false;
    }
    try {
        const parsed = new URL(value);
        const hostname = parsed.hostname.toLowerCase();
        const googleUserContent = hostname !== "googleusercontent.com" && hostname.endsWith(".googleusercontent.com");
        const approvedHost = googleUserContent || ALLOWED_AVATAR_HOSTS.has(hostname);
        return (parsed.protocol === "https:" &&
            approvedHost &&
            !parsed.username &&
            !parsed.password &&
            !parsed.port);
    }
    catch {
        return false;
    }
}
//# sourceMappingURL=avatar.js.map